import { render, staticRenderFns } from "./OrangeMobileRecovery.vue?vue&type=template&id=ed5aebd2&scoped=true"
import script from "./OrangeMobileRecovery.vue?vue&type=script&lang=js"
export * from "./OrangeMobileRecovery.vue?vue&type=script&lang=js"
import style0 from "./OrangeMobileRecovery.vue?vue&type=style&index=0&id=ed5aebd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5aebd2",
  null
  
)

export default component.exports